// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2LbZ3","dragIcon":"Choice_dragIcon__xsVlT","left":"Choice_left__1gU7s","input":"Choice_input__1reAI"};